import React, { useState, useEffect } from 'react';
import { FiPlus } from 'react-icons/fi';
import { faqAPI } from '../../api/services';
import { useTranslation } from 'react-i18next';

const FAQPage = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    faqAPI.getAll()
      .then(r => setFaqs(r.data?.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <>
      <div className="page-header">
        <div className="container">
          <img src="/illustrations/faq.png" alt="FAQ" className="page-header-illustration" />
          <span className="section-label">{t('faq_page.label')}</span>
          <h1>{t('faq_page.title')}</h1>
          <p>{t('faq_page.subtitle')}</p>
        </div>
      </div>

      <section className="section" style={{ paddingTop: 32 }}>
        <div className="container" style={{ maxWidth: 720 }}>
          {loading ? (
            <div className="loading"><div className="spinner"></div></div>
          ) : faqs.length === 0 ? (
            <div className="empty-state">
              <div className="icon">❓</div>
              <h3>{t('faq_page.no_faqs')}</h3>
              <p>{t('faq_page.preparing')}</p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {faqs.map((faq, i) => (
                <div key={faq.id} className="faq-item">
                  <button className="faq-question" onClick={() => toggle(i)}>
                    <span>{faq.question}</span>
                    <FiPlus className={`icon ${openIndex === i ? 'open' : ''}`} />
                  </button>
                  {openIndex === i && (
                    <div className="faq-answer">{faq.answer}</div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default FAQPage;
